import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Input, Textarea } from "formsy-react-components";
import Formsy from "formsy-react";

import moment from "moment";
import isObject from "lodash/isObject";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import sortBy from "lodash/sortBy";
import { orderBy } from "lodash";

import DateTimePicker from "../common/DateTimePicker";
import DropdownSearch from "../common/DropdownSearch";

class SupportTicketForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      customer: {},
      contract: {},
      project: ""
    };
  }

  componentDidMount = () => {
    if (this.props.call) {
      const call_type = find(this.props.codes, {
        _id: this.props.call.project.call_type
      });
      this.setState({
        customer: this.props.call.customer,
        project: this.props.call.project._id,
        call_type
      });
    }

    if (this.props.supportTicket?.createdFromCustomerPortal) {
      this.setState({
        customer: this.props.supportTicket.customer
      });
    }

    if (this.props.callDefaultCustomer) {
      this.loadDefaultCustomer(this.props);
    }

    if (this.props.callDefaultProject) {
      this.loadDefaultProject(this.props);
    }

    this.loadDefaultAssignedTo(this.props);
    this.loadDefaultRequestor(this.props);
    this.loadInternalInformation(this.props);
  };

  onChange = (field, input) => {
    if (field === "customer") {
      const customer = find(this.props.customers, { _id: input.value });
      this.setState({ customer, contract: {} });
    } else if (field === "project") {
      const project = this.props.projects.find(
        (proj) => proj._id === input.value
      );
      const call_type = this.props.codes.find(
        (code) =>
          code.entity === "Call" && code.value === project.call_type.value
      );
      this.setState({
        project: project._id,
        contract: project.contract || {},
        call_type,
        fullProject: project
      });
    } else if (field === "assigned_to") {
      const assigned_to = find(this.props.users, { _id: input.value });
      this.setState({ assigned_to });
    } else {
      this.setState({ [field]: input.value });
    }
  };

  onChangeDate = (date, name) => {
    this.setState({ [name]: date });
  };

  loadDefaultRequestor = (props) => {
    const { supportTicket } = props;
    if (!isEmpty(supportTicket)) {
      this.setState({ requestor_full_name: supportTicket.requestor_full_name });
    }
  };

  loadInternalInformation = (props) => {
    const { supportTicket } = props;
    if (!isEmpty(supportTicket)) {
      this.setState({
        internal_note: supportTicket.internal_note,
        internal_cc: supportTicket.internal_cc?._id
      });
    }
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  add = (call) => {
    const { supportTicket } = this.props;
    const stage = find(this.props.codes, { entity: "Call", label: "Reserved" });
    const priority = find(this.props.codes, {
      entity: "Call",
      field: "priority",
      label: supportTicket.request_priority
    });

    const roundedMinute = Math.ceil(moment().minute() / 15) * 15;

    const arrival =
      this.state.arrival_date || moment().minute(roundedMinute).second(0);

    const { department } = this.state.assigned_to;

    const defaults = {};

    if (department.default_service) {
      defaults.service = department.default_service;
    }
    if (department.default_service && department.default_task) {
      defaults.tasks = [
        {
          service: department.default_service,
          service_task: department.default_task,
          duration_units: "Hours",
          actual_duration: 0
        }
      ];
    }

    const createCall = {
      ...call,
      ...defaults,
      actual_hrs: 0,
      arrival_date: arrival,
      completed_date: moment(arrival).add(0.5, "hour"),
      contract: this.state.contract && this.state.contract._id,
      call_type: this.state.call_type._id,
      department: department._id,
      stage: stage._id,
      priority: priority._id,
      support_ticket_id: supportTicket._id
    };
    this.props.onSave(createCall);
  };

  cancel = () => {
    this.props.onCancel();
  };

  addContact = async () => {
    await this.props.addContact();
    this.setState({ customer: this.state.customer });
  };

  loadDefaultCustomer = (props) => {
    const { supportTicket, customers } = props;

    if (
      !isEmpty(supportTicket) &&
      !supportTicket.is_assigned &&
      supportTicket.autoGeneratedCustomerMatch
    ) {
      const customer = customers.find(
        (c) => c._id === supportTicket.autoGeneratedCustomerMatch
      );

      if (customer) {
        this.setState({ customer });
      }
    }
  };

  loadDefaultAssignedTo = (props) => {
    const { users, auth, supportTicket, call, isFollowUp } = props;
    if (!isEmpty(users) && !isEmpty(supportTicket)) {
      if (isFollowUp) {
        const assigned_to = find(users, {
          _id: call.assigned_to
        });
        this.setState({ assigned_to });
      } else if (supportTicket.assigned_to) {
        const assigned_to = find(users, {
          _id: supportTicket.assigned_to
        });
        if (assigned_to) {
          this.setState({ assigned_to });
        } else {
          const defaultAssignedTo = find(users, { _id: auth.user._id });
          this.setState({ assigned_to: defaultAssignedTo });
        }
      } else if (supportTicket.autoGeneratedEmployeeMatch) {
        const assigned_to = find(users, {
          _id: supportTicket.autoGeneratedEmployeeMatch
        });
        this.setState({ assigned_to });
      } else {
        const assigned_to = find(users, { _id: auth.user._id });
        this.setState({ assigned_to });
      }
    }
  };

  loadDefaultProject = (props) => {
    const { supportTicket, projects } = props;
    if (
      !isEmpty(projects) &&
      !isEmpty(supportTicket) &&
      !supportTicket.is_assigned &&
      supportTicket.autoGeneratedProjectMatch
    ) {
      const project = projects.find(
        (proj) => proj._id === supportTicket.autoGeneratedProjectMatch
      );
      const call_type = this.props.codes.find(
        (code) =>
          code.entity === "Call" && code.value === project?.call_type?.value
      );

      this.setState({
        call_type,
        project: supportTicket.autoGeneratedProjectMatch,
        contract: project.contract || {}
      });
    }
  };

  // ----- GENERATORS --------

  genContractOptions = () => {
    let contractOptions = [];

    if (this.state.customer) {
      contractOptions = this.props.contracts
        .filter(
          (contract) =>
            contract.customer &&
            contract.customer._id === this.state.customer._id
        )
        .map((contract) => ({ value: contract._id, label: contract.name }));
    }

    return sortBy(contractOptions, "label");
  };

  genProjectOptions = () => {
    let projectOptions = [];
    projectOptions = this.props.projects
      .filter(
        (project) =>
          project.customer &&
          project.customer._id === this.state.customer?._id &&
          project.project_status.value === "IP"
      )
      .map((project) => ({ value: project._id, label: project.name }));

    return sortBy(projectOptions, "label");
  };

  genContactOptions = () => {
    let contactOptions = [];
    if (this.state.customer) {
      contactOptions = this.state.customer.contacts.map((contact) => ({
        value: contact._id,
        label: contact.full_name
      }));
    }

    contactOptions = sortBy(contactOptions, "label");

    contactOptions.push({
      value: null,
      label: "Add New Contact"
    });

    return contactOptions;
  };

  genAssignedToOptions = () => {
    let assignedToOptions = [];
    if (this.props.auth.maxRole <= 9000) {
      assignedToOptions = this.props.users;
    }

    return sortBy(
      assignedToOptions.map((user) => ({
        value: user._id,
        label: user.full_name
      })),
      "label"
    );
  };

  genUserCcOptions = () => {
    const options = sortBy(
      this.props.users.map((user) => ({
        value: user._id,
        label: user.full_name
      })),
      "label"
    );
    return options;
  };

  generateWorkplaceOptions = () => {
    const workplaceOptions = this.props.codes
      .filter((code) => code.entity === "Call" && code.field === "workplace")
      .map((code) => ({ value: code._id, label: code.label }));
    return orderBy(workplaceOptions, [(option) => option.label.toLowerCase()]);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.customers.length &&
      !isEmpty(nextProps.supportTicket) &&
      (nextProps.supportTicket.customer !== this.state.customer ||
        nextProps.supportTicket.autoGeneratedCustomerMatch !==
          this.state.customer)
    ) {
      this.loadDefaultRequestor(nextProps);
      this.loadInternalInformation(nextProps);
      this.loadDefaultCustomer(nextProps);
    }

    if (
      nextProps.users.length &&
      !isEmpty(nextProps.supportTicket) &&
      (nextProps.supportTicket.assigned_to !== this.state.assigned_to ||
        nextProps.supportTicket.autoGeneratedEmployeeMatch !==
          this.state.assigned_to ||
        (!nextProps.supportTicket.is_assigned && !this.state.assigned_to))
    ) {
      this.loadDefaultAssignedTo(nextProps);
    }

    if (
      nextProps.projects.length &&
      !isEmpty(nextProps.supportTicket) &&
      (nextProps.supportTicket.project !== this.state.project ||
        nextProps.supportTicket.autoGeneratedProjectMatch !==
          this.state.project)
    ) {
      this.loadDefaultProject(nextProps);
    }
  };

  render() {
    const { customers } = this.props;
    const { customer } = this.state;

    return (
      <div>
        <Formsy
          className="vertical form"
          onValidSubmit={this.add}
          onValid={this.enableButton}
          onInvalid={this.disableButton}
        >
          <Row>
            <Col md={6} xs={12}>
              <DropdownSearch
                required
                name="customer"
                label="Customer"
                onChange={this.onChange}
                data={[
                  ...customers.map((cust) => ({
                    value: cust._id,
                    label: cust.name
                  }))
                ]}
                value={isObject(customer) ? customer._id : customer}
                disabled={
                  this.props.customerDisabled ||
                  this.props.supportTicket?.createdFromCustomerPortal
                }
                isNightMode={this.props.auth.isNightMode}
                aiGeneratedValue={
                  this.props.supportTicket?.autoGeneratedCustomerMatch
                }
              />
            </Col>
            <Col md={6} xs={12}>
              <DropdownSearch
                required
                name="project"
                label="Project"
                data={[...this.genProjectOptions()]}
                onChange={this.onChange}
                value={this.state.project}
                isNightMode={this.props.auth.isNightMode}
                aiGeneratedValue={
                  this.props.supportTicket?.autoGeneratedProjectMatch
                }
              />
            </Col>
            <Col md={6} xs={12}>
              <DropdownSearch
                name="assigned_to"
                label="Assigned To"
                onChange={this.onChange}
                data={[...this.genAssignedToOptions()]}
                value={
                  this.state.assigned_to
                    ? this.state.assigned_to._id
                    : this.props.auth.user._id
                }
                isNightMode={this.props.auth.isNightMode}
                aiGeneratedValue={
                  this.props.supportTicket?.autoGeneratedEmployeeMatch
                }
              />
            </Col>
            <Col md={6} xs={12}>
              <Input
                required
                name="project_requestor"
                label="Requestor"
                value={this.state.requestor_full_name}
              />
            </Col>
            <Col md={4} xs={12}>
              <DateTimePicker
                // required
                name="arrival_date"
                label="Call Start Time"
                onChange={this.onChangeDate}
                value={this.state.arrival_date}
              />
            </Col>
            <Col md={4} xs={12}>
              <DropdownSearch
                label="Workplace"
                name="workplace"
                onChange={this.onChange}
                value={this?.state?.workplace}
                data={[...this.generateWorkplaceOptions()]}
              />
            </Col>
            <Col md={4} xs={12}>
              <DropdownSearch
                name="internal_cc"
                label="Internal CC"
                onChange={this.onChange}
                data={[...this.genUserCcOptions()]}
                value={this.state.internal_cc}
              />
            </Col>
            <Col md={12} xs={12}>
              <Textarea
                type="text"
                name="internal_note"
                label="Internal Notes"
                value={this.state.internal_note}
                validations={{ maxLength: 250 }}
                validationErrors={{
                  maxLength: "You can not type in more than 250 characters"
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} className="footer">
              <button
                className="btn btn-cancel"
                type="button"
                onClick={this.cancel}
              >
                Cancel
              </button>
              <input
                className="btn btn-success"
                type="submit"
                disabled={!this.state.canSubmit || this.props.saving}
                value={this.props.saving ? "Saving... " : "Save"}
              />
            </Col>
          </Row>
        </Formsy>
      </div>
    );
  }
}

SupportTicketForm.propTypes = {
  saving: PropTypes.bool,
  onSave: PropTypes.func,
  auth: PropTypes.object,
  call: PropTypes.object,
  customers: PropTypes.array,
  users: PropTypes.array,
  contracts: PropTypes.array,
  codes: PropTypes.array,
  addContact: PropTypes.func,
  onCancel: PropTypes.func,
  supportTicket: PropTypes.object,
  projects: PropTypes.array,
  customerDisabled: PropTypes.bool,
  callDefaultCustomer: PropTypes.bool,
  callDefaultProject: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    recurrence: state.reducers.recurrence,
    supportTicket: state.reducers.supportTicket,
    customer: state.reducers.customer,
    customers: state.reducers.customers,
    projects: state.reducers.projects
  };
}

export default connect(mapStatesToProps, null)(SupportTicketForm);
